var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 34,
    stroke: "#314064",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 68C55.2401 68 68 55.2401 68 39.5C68 23.7599 55.2401 11 39.5 11C23.7599 11 11 23.7599 11 39.5",
    stroke: "#EFF3F9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0556 45.0654L42.963 43.1567C46.1233 39.9944 46.1233 34.8673 42.963 31.705C39.8027 28.5427 34.6787 28.5427 31.5184 31.705L27.7035 35.5222C24.5432 38.6846 24.5432 43.8117 27.7035 46.974C29.1691 48.4405 31.057 49.2269 32.9755 49.3333",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9444 34.9346L37.037 36.8433C33.8767 40.0056 33.8767 45.1327 37.037 48.295C40.1973 51.4573 45.3213 51.4573 48.4816 48.295L52.2965 44.4778C55.4568 41.3154 55.4568 36.1883 52.2965 33.026C50.8309 31.5595 48.943 30.7731 47.0245 30.6667",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.50057018c26712192a99d7fc1a770912.svg";
export { ForwardRef as ReactComponent };